import React from 'react';
import styles from '../WifiConnect.module.scss';
import { AppConfig } from '../../../constants/config';

export const WarningMessage: React.FC = () => {
  return AppConfig.showWarningMessage ? (
    <div className={styles.notification}>
      The public certificate for WeWorkWiFi will be updated on{' '}
      <strong>Saturday November 7th from 7-8am ET</strong>. When prompted,
      please trust the certificate and server.
      <br />
      <br />
      If you experience any issues, please forget WeWorkWiFi and try connecting
      again.
    </div>
  ) : (
    <></>
  );
};
